// extracted by mini-css-extract-plugin
module.exports = {"root":"vote_root__3I6HK","inner":"vote_inner__2ZuQ_","loading":"vote_loading__27wAL","item_wrap":"vote_item_wrap__CyYh6"};